import { getEndpointPathBuilders } from './endpoint.ts'
import type { Url } from '#server/types/common'

const { action } = getEndpointPathBuilders('invitations')

export default {
  byEmails: action('by-emails'),
  validateToken: (token: string, email: string) => action('validate-token', { token, email }) as Url,
}
